/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * BeDrive
 * In the documentation API requests will be sent from currently logged in user so you do not need to provide a bearer token manually. <br><br> When calling API from outside the documentation, you will need to provide an access token for all requests in authorization header: `Authorization: Bearer <Token>` <br> You can create a new access token in your account settings page.
 * OpenAPI spec version: 1.0.0
 */
import type {AbortS3MultipartUploadBody} from './schemas/abort-s3-multipart-upload-body';

import type {AddPreviewToken200} from './schemas/add-preview-token200';

import type {BatchSignS3PartUrlsBody} from './schemas/batch-sign-s3-part-urls-body';

import type {BatchSignS3PartUrls200} from './schemas/batch-sign-s3-part-urls200';

import type {BulkDeleteFileEntriesBody} from './schemas/bulk-delete-file-entries-body';

import type {CompleteS3MultipartUploadBody} from './schemas/complete-s3-multipart-upload-body';

import type {CompleteS3MultipartUpload200} from './schemas/complete-s3-multipart-upload200';

import type {CreateFolderBody} from './schemas/create-folder-body';

import type {CreateFolder200} from './schemas/create-folder200';

import type {CreateS3FileEntryBody} from './schemas/create-s3-file-entry-body';

import type {CreateS3FileEntry200} from './schemas/create-s3-file-entry200';

import type {CreateS3MultipartUploadBody} from './schemas/create-s3-multipart-upload-body';

import type {CreateS3MultipartUpload200} from './schemas/create-s3-multipart-upload200';

import type {DuplicateEntriesBody} from './schemas/duplicate-entries-body';

import type {DuplicateEntries200} from './schemas/duplicate-entries200';

import type {GetFolderPathParams} from './schemas/get-folder-path-params';

import type {GetFolderPath200} from './schemas/get-folder-path200';

import type {GetS3UploadedPartsBody} from './schemas/get-s3-uploaded-parts-body';

import type {GetS3UploadedParts200} from './schemas/get-s3-uploaded-parts200';

import type {GetUserSpaceUsage200} from './schemas/get-user-space-usage200';

import type {ListDriveEntriesParams} from './schemas/list-drive-entries-params';

import type {ListDriveEntries200} from './schemas/list-drive-entries200';

import type {ListFileEntriesParams} from './schemas/list-file-entries-params';

import type {ListFileEntries200} from './schemas/list-file-entries200';

import type {ListWorkspaceFolders200} from './schemas/list-workspace-folders200';

import type {MoveFileEntriesBody} from './schemas/move-file-entries-body';

import type {MoveFileEntries200} from './schemas/move-file-entries200';

import type {PresignS3PostUrlBody} from './schemas/presign-s3-post-url-body';

import type {PresignS3PostUrl200} from './schemas/presign-s3-post-url200';

import type {RestoreDeletedEntriesBody} from './schemas/restore-deleted-entries-body';

import type {RetrieveDriveEntryModel200} from './schemas/retrieve-drive-entry-model200';

import type {RetrieveFileEntryContent200} from './schemas/retrieve-file-entry-content200';

import type {RetrieveFileEntryModel200} from './schemas/retrieve-file-entry-model200';

import type {SimpleFileUploadBody} from './schemas/simple-file-upload-body';

import type {SimpleFileUpload200} from './schemas/simple-file-upload200';

import type {StarEntriesBody} from './schemas/star-entries-body';

import type {StoreTusFileEntryBody} from './schemas/store-tus-file-entry-body';

import type {StoreTusFileEntry200} from './schemas/store-tus-file-entry200';

import type {UnstarEntriesBody} from './schemas/unstar-entries-body';

import type {UpdateDriveEntryBody} from './schemas/update-drive-entry-body';

import type {UpdateDriveEntry200} from './schemas/update-drive-entry200';

import type {UpdateFileEntryBody} from './schemas/update-file-entry-body';

import type {UpdateFileEntry200} from './schemas/update-file-entry200';

import {orvalApiFetch} from '../../../common/foundation/resources/client/http/query-client';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Retrieve file metadata
 */
export const retrieveDriveEntryModel = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveDriveEntryModel200>>,
) => {
  return orvalApiFetch<RetrieveDriveEntryModel200>(
    {url: `/drive/file-entries/${id}/model`, method: 'GET'},
    options,
  );
};
/**
 * @summary List all files
 */
export const listDriveEntries = (
  params: ListDriveEntriesParams,
  options?: SecondParameter<typeof orvalApiFetch<ListDriveEntries200>>,
) => {
  return orvalApiFetch<ListDriveEntries200>(
    {url: `/drive/file-entries`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Update file metadata
 */
export const updateDriveEntry = (
  id: number,
  updateDriveEntryBody?: UpdateDriveEntryBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateDriveEntry200>>,
) => {
  return orvalApiFetch<UpdateDriveEntry200>(
    {
      url: `/drive/file-entries/${id}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: updateDriveEntryBody,
    },
    options,
  );
};
/**
 * @summary Move files
 */
export const moveFileEntries = (
  moveFileEntriesBody: MoveFileEntriesBody,
  options?: SecondParameter<typeof orvalApiFetch<MoveFileEntries200>>,
) => {
  return orvalApiFetch<MoveFileEntries200>(
    {
      url: `/file-entries/move`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: moveFileEntriesBody,
    },
    options,
  );
};
/**
 * @summary Duplicate files
 */
export const duplicateEntries = (
  duplicateEntriesBody: DuplicateEntriesBody,
  options?: SecondParameter<typeof orvalApiFetch<DuplicateEntries200>>,
) => {
  return orvalApiFetch<DuplicateEntries200>(
    {
      url: `/file-entries/duplicate`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: duplicateEntriesBody,
    },
    options,
  );
};
/**
 * @summary Create a new folder
 */
export const createFolder = (
  createFolderBody: CreateFolderBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateFolder200>>,
) => {
  return orvalApiFetch<CreateFolder200>(
    {
      url: `/folders`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createFolderBody,
    },
    options,
  );
};
/**
 * @summary Get all workspace folders in compact format
 */
export const listWorkspaceFolders = (
  options?: SecondParameter<typeof orvalApiFetch<ListWorkspaceFolders200>>,
) => {
  return orvalApiFetch<ListWorkspaceFolders200>(
    {url: `/drive/workspace-folders`, method: 'GET'},
    options,
  );
};
/**
 * @summary Get full path for a folder
 */
export const getFolderPath = (
  hash: string,
  params?: GetFolderPathParams,
  options?: SecondParameter<typeof orvalApiFetch<GetFolderPath200>>,
) => {
  return orvalApiFetch<GetFolderPath200>(
    {url: `/folders/${hash}/path`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Star files
 */
export const starEntries = (
  starEntriesBody: StarEntriesBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/file-entries/star`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: starEntriesBody,
    },
    options,
  );
};
/**
 * @summary Unstar files
 */
export const unstarEntries = (
  unstarEntriesBody: UnstarEntriesBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/file-entries/unstar`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: unstarEntriesBody,
    },
    options,
  );
};
/**
 * @summary Retrieve file metadata
 */
export const retrieveFileEntryModel = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveFileEntryModel200>>,
) => {
  return orvalApiFetch<RetrieveFileEntryModel200>(
    {url: `/file-entries/${id}/model`, method: 'GET'},
    options,
  );
};
/**
 * @summary Retrieve file content
 */
export const retrieveFileEntryContent = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<RetrieveFileEntryContent200>>,
) => {
  return orvalApiFetch<RetrieveFileEntryContent200>(
    {url: `/file-entries/${id}`, method: 'GET'},
    options,
  );
};
/**
 * @summary List all files
 */
export const listFileEntries = (
  params?: ListFileEntriesParams,
  options?: SecondParameter<typeof orvalApiFetch<ListFileEntries200>>,
) => {
  return orvalApiFetch<ListFileEntries200>(
    {url: `/file-entries`, method: 'GET', params},
    options,
  );
};
/**
 * @summary Upload a file
 */
export const simpleFileUpload = (
  simpleFileUploadBody: SimpleFileUploadBody,
  options?: SecondParameter<typeof orvalApiFetch<SimpleFileUpload200>>,
) => {
  const formData = new FormData();
  formData.append(`file`, simpleFileUploadBody.file);
  if (
    simpleFileUploadBody.parentId !== undefined &&
    simpleFileUploadBody.parentId !== null
  ) {
    formData.append(`parentId`, simpleFileUploadBody.parentId.toString());
  }
  if (
    simpleFileUploadBody.relativePath !== undefined &&
    simpleFileUploadBody.relativePath !== null
  ) {
    formData.append(`relativePath`, simpleFileUploadBody.relativePath);
  }

  return orvalApiFetch<SimpleFileUpload200>(
    {
      url: `/file-entries`,
      method: 'POST',
      headers: {'Content-Type': 'multipart/form-data'},
      data: formData,
    },
    options,
  );
};
/**
 * @summary Update file metadata
 */
export const updateFileEntry = (
  entryId: number,
  updateFileEntryBody?: UpdateFileEntryBody,
  options?: SecondParameter<typeof orvalApiFetch<UpdateFileEntry200>>,
) => {
  return orvalApiFetch<UpdateFileEntry200>(
    {
      url: `/file-entries/${entryId}`,
      method: 'PUT',
      headers: {'Content-Type': 'application/json'},
      data: updateFileEntryBody,
    },
    options,
  );
};
/**
 * @summary Bulk delete files
 */
export const bulkDeleteFileEntries = (
  bulkDeleteFileEntriesBody?: BulkDeleteFileEntriesBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/file-entries/bulk-delete`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: bulkDeleteFileEntriesBody,
    },
    options,
  );
};
/**
 * @summary Download files
 */
export const downloadFiles = (
  hashes: string,
  options?: SecondParameter<typeof orvalApiFetch<string>>,
) => {
  return orvalApiFetch<string>(
    {url: `/file-entries/download/${hashes}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Restore deleted files
 */
export const restoreDeletedEntries = (
  restoreDeletedEntriesBody: RestoreDeletedEntriesBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/file-entries/restore`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: restoreDeletedEntriesBody,
    },
    options,
  );
};
/**
 * @summary Add preview token to file entry
 */
export const addPreviewToken = (
  id: number,
  options?: SecondParameter<typeof orvalApiFetch<AddPreviewToken200>>,
) => {
  return orvalApiFetch<AddPreviewToken200>(
    {url: `/file-entries/${id}/add-preview-token`, method: 'POST'},
    options,
  );
};
/**
 * @summary Create s3 multipart upload
 */
export const createS3MultipartUpload = (
  createS3MultipartUploadBody: CreateS3MultipartUploadBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateS3MultipartUpload200>>,
) => {
  return orvalApiFetch<CreateS3MultipartUpload200>(
    {
      url: `/s3/multipart/create`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createS3MultipartUploadBody,
    },
    options,
  );
};
/**
 * @summary Batch sign s3 part urls
 */
export const batchSignS3PartUrls = (
  batchSignS3PartUrlsBody: BatchSignS3PartUrlsBody,
  options?: SecondParameter<typeof orvalApiFetch<BatchSignS3PartUrls200>>,
) => {
  return orvalApiFetch<BatchSignS3PartUrls200>(
    {
      url: `/s3/multipart/batch-sign-part-urls`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: batchSignS3PartUrlsBody,
    },
    options,
  );
};
/**
 * @summary Get s3 uploaded parts
 */
export const getS3UploadedParts = (
  getS3UploadedPartsBody: GetS3UploadedPartsBody,
  options?: SecondParameter<typeof orvalApiFetch<GetS3UploadedParts200>>,
) => {
  return orvalApiFetch<GetS3UploadedParts200>(
    {
      url: `/s3/multipart/get-uploaded-parts`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: getS3UploadedPartsBody,
    },
    options,
  );
};
/**
 * @summary Complete s3 multipart upload
 */
export const completeS3MultipartUpload = (
  completeS3MultipartUploadBody: CompleteS3MultipartUploadBody,
  options?: SecondParameter<typeof orvalApiFetch<CompleteS3MultipartUpload200>>,
) => {
  return orvalApiFetch<CompleteS3MultipartUpload200>(
    {
      url: `/s3/multipart/complete`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: completeS3MultipartUploadBody,
    },
    options,
  );
};
/**
 * @summary Abort s3 multipart upload
 */
export const abortS3MultipartUpload = (
  abortS3MultipartUploadBody: AbortS3MultipartUploadBody,
  options?: SecondParameter<typeof orvalApiFetch<void>>,
) => {
  return orvalApiFetch<void>(
    {
      url: `/s3/multipart/abort`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: abortS3MultipartUploadBody,
    },
    options,
  );
};
/**
 * @summary Presign s3 post url
 */
export const presignS3PostUrl = (
  presignS3PostUrlBody: PresignS3PostUrlBody,
  options?: SecondParameter<typeof orvalApiFetch<PresignS3PostUrl200>>,
) => {
  return orvalApiFetch<PresignS3PostUrl200>(
    {
      url: `/s3/simple/presign`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: presignS3PostUrlBody,
    },
    options,
  );
};
/**
 * @summary Create a new file entry
 */
export const createS3FileEntry = (
  createS3FileEntryBody: CreateS3FileEntryBody,
  options?: SecondParameter<typeof orvalApiFetch<CreateS3FileEntry200>>,
) => {
  return orvalApiFetch<CreateS3FileEntry200>(
    {
      url: `/s3/entries`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: createS3FileEntryBody,
    },
    options,
  );
};
/**
 * @summary Store tus file entry
 */
export const storeTusFileEntry = (
  storeTusFileEntryBody: StoreTusFileEntryBody,
  options?: SecondParameter<typeof orvalApiFetch<StoreTusFileEntry200>>,
) => {
  return orvalApiFetch<StoreTusFileEntry200>(
    {
      url: `/tus/entries`,
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      data: storeTusFileEntryBody,
    },
    options,
  );
};
export const tusTusServer = (
  any: string,
  options?: SecondParameter<typeof orvalApiFetch<string>>,
) => {
  return orvalApiFetch<string>(
    {url: `/tus/upload/${any}`, method: 'GET'},
    options,
  );
};
/**
 * @summary Get user space usage
 */
export const getUserSpaceUsage = (
  options?: SecondParameter<typeof orvalApiFetch<GetUserSpaceUsage200>>,
) => {
  return orvalApiFetch<GetUserSpaceUsage200>(
    {url: `/user/space-usage`, method: 'GET'},
    options,
  );
};
export type RetrieveDriveEntryModelResult = NonNullable<
  Awaited<ReturnType<typeof retrieveDriveEntryModel>>
>;
export type ListDriveEntriesResult = NonNullable<
  Awaited<ReturnType<typeof listDriveEntries>>
>;
export type UpdateDriveEntryResult = NonNullable<
  Awaited<ReturnType<typeof updateDriveEntry>>
>;
export type MoveFileEntriesResult = NonNullable<
  Awaited<ReturnType<typeof moveFileEntries>>
>;
export type DuplicateEntriesResult = NonNullable<
  Awaited<ReturnType<typeof duplicateEntries>>
>;
export type CreateFolderResult = NonNullable<
  Awaited<ReturnType<typeof createFolder>>
>;
export type ListWorkspaceFoldersResult = NonNullable<
  Awaited<ReturnType<typeof listWorkspaceFolders>>
>;
export type GetFolderPathResult = NonNullable<
  Awaited<ReturnType<typeof getFolderPath>>
>;
export type StarEntriesResult = NonNullable<
  Awaited<ReturnType<typeof starEntries>>
>;
export type UnstarEntriesResult = NonNullable<
  Awaited<ReturnType<typeof unstarEntries>>
>;
export type RetrieveFileEntryModelResult = NonNullable<
  Awaited<ReturnType<typeof retrieveFileEntryModel>>
>;
export type RetrieveFileEntryContentResult = NonNullable<
  Awaited<ReturnType<typeof retrieveFileEntryContent>>
>;
export type ListFileEntriesResult = NonNullable<
  Awaited<ReturnType<typeof listFileEntries>>
>;
export type SimpleFileUploadResult = NonNullable<
  Awaited<ReturnType<typeof simpleFileUpload>>
>;
export type UpdateFileEntryResult = NonNullable<
  Awaited<ReturnType<typeof updateFileEntry>>
>;
export type BulkDeleteFileEntriesResult = NonNullable<
  Awaited<ReturnType<typeof bulkDeleteFileEntries>>
>;
export type DownloadFilesResult = NonNullable<
  Awaited<ReturnType<typeof downloadFiles>>
>;
export type RestoreDeletedEntriesResult = NonNullable<
  Awaited<ReturnType<typeof restoreDeletedEntries>>
>;
export type AddPreviewTokenResult = NonNullable<
  Awaited<ReturnType<typeof addPreviewToken>>
>;
export type CreateS3MultipartUploadResult = NonNullable<
  Awaited<ReturnType<typeof createS3MultipartUpload>>
>;
export type BatchSignS3PartUrlsResult = NonNullable<
  Awaited<ReturnType<typeof batchSignS3PartUrls>>
>;
export type GetS3UploadedPartsResult = NonNullable<
  Awaited<ReturnType<typeof getS3UploadedParts>>
>;
export type CompleteS3MultipartUploadResult = NonNullable<
  Awaited<ReturnType<typeof completeS3MultipartUpload>>
>;
export type AbortS3MultipartUploadResult = NonNullable<
  Awaited<ReturnType<typeof abortS3MultipartUpload>>
>;
export type PresignS3PostUrlResult = NonNullable<
  Awaited<ReturnType<typeof presignS3PostUrl>>
>;
export type CreateS3FileEntryResult = NonNullable<
  Awaited<ReturnType<typeof createS3FileEntry>>
>;
export type StoreTusFileEntryResult = NonNullable<
  Awaited<ReturnType<typeof storeTusFileEntry>>
>;
export type TusTusServerResult = NonNullable<
  Awaited<ReturnType<typeof tusTusServer>>
>;
export type GetUserSpaceUsageResult = NonNullable<
  Awaited<ReturnType<typeof getUserSpaceUsage>>
>;
